import { Routes } from '@angular/router';

export const appRoutes: Routes = [
    {
        path: '',
        loadChildren: () => import(/* webpackChunkName: "AuthModule" */ './pages/auth/auth.module').then((m) => m.AuthModule),
    },
    {
        path: 'dashboard',
        loadChildren: () =>
            import(/* webpackChunkName: "DashboardModule" */ './pages/dashboard/dashboard.module').then((m) => m.DashboardModule),
    },
    {
        path: 'leads',
        loadChildren: () => import(/* webpackChunkName: "LeadsModule" */ './pages/leads/leads.module').then((m) => m.LeadsModule),
    },
    {
        path: 'onboarding',
        loadChildren: () =>
            import(/* webpackChunkName: "OnboardingModule" */ './pages/onboarding/onboarding.module').then((m) => m.OnboardingModule),
    },
    {
        path: 'price',
        loadChildren: () =>
            import(/* webpackChunkName: "CataloguesModule" */ './pages/catalogues/catalogues.module').then((m) => m.CataloguesModule),
    },
    {
        path: 'account',
        loadChildren: () => import(/* webpackChunkName: "AccountModule" */ './pages/account/account.module').then((m) => m.AccountModule),
    },
    {
        path: 'integrations',
        loadChildren: () =>
            import(/* webpackChunkName: "IntegrationsV2Module" */ './pages/integrations-v2/integrations-v2.module').then(
                (m) => m.IntegrationsV2Module
            ),
    },
    {
        path: 'application-integrations/sync-logs',
        loadChildren: () =>
            import(
                /* webpackChunkName: "ApplicationIntegrationsSyncLogsModule" */ './pages/integrations-v2/application-integrations-sync-logs/application-integrations-sync-logs.module'
            ).then((m) => m.ApplicationIntegrationsSyncLogsModule),
    },
    {
        path: 'application-integrations/connection',
        loadChildren: () =>
            import(
                /* webpackChunkName: "ApplicationIntegrationsConnectionDetailsModule" */ './pages/integrations-v2/application-integrations-connection-details/application-integrations-connection-details.module'
            ).then((m) => m.ApplicationIntegrationsConnectionDetailsModule),
    },
    {
        path: 'preview-features',
        loadChildren: () =>
            import(/* webpackChunkName: "PreviewFeaturesModule" */ './pages/preview-features/preview-features.module').then(
                (m) => m.PreviewFeaturesModule
            ),
    },
    {
        path: 'contacts',
        loadChildren: () =>
            import(/* webpackChunkName: "ContactsModule" */ './pages/contacts/contacts.module').then((m) => m.ContactsModule),
    },
    {
        path: 'customers',
        loadChildren: () => import(/* webpackChunkName: "ClientsModule" */ './pages/clients/clients.module').then((m) => m.ClientsModule),
    },
    {
        path: 'messages',
        loadChildren: () => import(/* webpackChunkName: "CommsModule" */ './pages/messages/comms.module').then((m) => m.CommsModule),
    },
    {
        path: 'estimates',
        loadChildren: () =>
            import(/* webpackChunkName: "EstimatesModule" */ './pages/estimates/estimates.module').then((m) => m.EstimatesModule),
    },
    {
        path: 'quoterequests',
        loadChildren: () =>
            import(/* webpackChunkName: "QuoteRequestsModule" */ './pages/quoterequests/quoterequest.module').then(
                (m) => m.QuoteRequestsModule
            ),
    },
    {
        path: 'jobs',
        loadChildren: () => import(/* webpackChunkName: "JobsModule" */ './pages/jobs/jobs.module').then((m) => m.JobsModule),
    },
    {
        path: 'resources',
        loadChildren: () =>
            import(/* webpackChunkName: "ResourcesModule" */ './pages/resouces/resouces.module').then((m) => m.ResoucesModule),
    },
    { path: '**', redirectTo: 'dashboard', pathMatch: 'full' },
];
